import { GOOGLE_API_KEY } from 'FielderUtils/session/Session.js';
export const mapConfig = {
  id: `google-map-script`,
  googleMapsApiKey: GOOGLE_API_KEY,
  libraries: ['geometry', 'drawing', 'places'],
  mapCoverageId: process.env.GOOGLE_MAP_COVERAGE_ID
};
export const defaultCenter = {
  lat: 28.6659874,
  lng: -41.0840058,
};
